export default "__VITE_ASSET__kA7ANMbO__"